import axiosInstance from './axiosInstance';

const saveOrder = (data) =>
  axiosInstance.patch('/internal/admin/config/carousels/order', { data });

export default saveOrder;
